"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalDataPrincipleContent = void 0;
const lib_1 = require("@brandfree-front/lib");
const react_1 = __importDefault(require("react"));
const PublicPrivacyNoticeModalContentUtil_1 = require("./PublicPrivacyNoticeModalContentUtil");
const RootStore_1 = require("../../../stores/RootStore");
const PersonalDataPrincipleContent = () => {
    const { translate } = react_1.default.useContext(RootStore_1.RootStoreContext).translateStore;
    const personalDataPrincipleRows = [
        {
            content: translate('gdpr.privacy.notification.paragraph.six.table.column1.item1'),
            type: translate('gdpr.privacy.notification.paragraph.six.table.column2.item1')
        },
        {
            content: translate('gdpr.privacy.notification.paragraph.six.table.column1.item2'),
            type: translate('gdpr.privacy.notification.paragraph.six.table.column2.item2')
        },
        {
            content: translate('gdpr.privacy.notification.paragraph.six.table.column1.item3'),
            type: translate('gdpr.privacy.notification.paragraph.six.table.column2.item3')
        },
        {
            content: translate('gdpr.privacy.notification.paragraph.six.table.column1.item4'),
            type: translate('gdpr.privacy.notification.paragraph.six.table.column2.item4')
        },
        {
            content: translate('gdpr.privacy.notification.paragraph.six.table.column1.item5'),
            type: translate('gdpr.privacy.notification.paragraph.six.table.column2.item5')
        },
        {
            content: translate('gdpr.privacy.notification.paragraph.six.table.column1.item6'),
            type: translate('gdpr.privacy.notification.paragraph.six.table.column2.item6')
        },
        {
            content: translate('gdpr.privacy.notification.paragraph.six.table.column1.item7'),
            type: translate('gdpr.privacy.notification.paragraph.six.table.column2.item7')
        },
        {
            content: translate('gdpr.privacy.notification.paragraph.six.table.column1.item8'),
            type: translate('gdpr.privacy.notification.paragraph.six.table.column2.item8')
        },
        {
            content: translate('gdpr.privacy.notification.paragraph.six.table.column1.item9'),
            type: translate('gdpr.privacy.notification.paragraph.six.table.column2.item9')
        },
        {
            content: translate('gdpr.privacy.notification.paragraph.six.table.column1.item10'),
            type: translate('gdpr.privacy.notification.paragraph.six.table.column2.item10')
        },
        {
            content: translate('gdpr.privacy.notification.paragraph.six.table.column1.item11'),
            type: translate('gdpr.privacy.notification.paragraph.six.table.column2.item11')
        },
        {
            content: translate('gdpr.privacy.notification.paragraph.six.table.column1.item12'),
            type: translate('gdpr.privacy.notification.paragraph.six.table.column2.item12')
        },
        {
            content: translate('gdpr.privacy.notification.paragraph.six.table.column1.item13'),
            type: translate('gdpr.privacy.notification.paragraph.six.table.column2.item13')
        }
    ];
    return (react_1.default.createElement(lib_1.Text, null,
        react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.six.text')),
        react_1.default.createElement(PublicPrivacyNoticeModalContentUtil_1.DataProcessingTable, { data: personalDataPrincipleRows })));
};
exports.PersonalDataPrincipleContent = PersonalDataPrincipleContent;
